import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalHeaderComponent } from './modal-header.component';
import { ButtonModule } from '../button/button.module';
import { TitleModule } from '../title/title.module';
import { IconModule } from '../icon/icon.module';

@NgModule({
  declarations: [ModalHeaderComponent],
  imports: [CommonModule, ButtonModule, TitleModule, IconModule],
  exports: [ModalHeaderComponent],
})
export class ModalHeaderModule {}
